// Cart drawer — open/close + real WC AJAX qty/remove via wc-ajax endpoints.
// Body markup pochodzi z `woocommerce/cart/mini-cart.php` (wstrzykiwany przez wc_cart_fragments
// jako fragment `div[data-cart-body]`).
//
// AJAX endpoints (Woo):
//   ?wc-ajax=remove_from_cart  -> { cart_item_key }
//   ?wc-ajax=kb_update_cart    -> { cart_item_key, qty } (własny, inc/cart-fragments.php — rdzeń nie ma update_cart)
// Po sukcesie wc_cart_fragments_refreshed event -> re-render body.

function getShopBase() {
  // KB.shopUrl jest localizowane w inc/enqueue.php; fallback do origin.
  if (typeof window !== 'undefined' && window.KB && window.KB.shopUrl) return window.KB.shopUrl;
  return window.location.origin + '/';
}

function wcAjaxUrl(action) {
  const base = getShopBase();
  const sep = base.indexOf('?') === -1 ? '?' : '&';
  return base + sep + 'wc-ajax=' + encodeURIComponent(action);
}

function triggerFragmentRefresh() {
  if (window.jQuery) {
    window.jQuery(document.body).trigger('wc_fragment_refresh');
  } else {
    // Bez jQuery — manualnie refetchujemy fragmenty.
    fetch(wcAjaxUrl('get_refreshed_fragments'), { method: 'POST', credentials: 'same-origin' })
      .then((r) => r.json())
      .then((json) => {
        if (json && json.fragments) applyFragments(json.fragments);
      })
      .catch(() => {});
  }
}

function applyFragments(fragments) {
  Object.keys(fragments).forEach((selector) => {
    document.querySelectorAll(selector).forEach((el) => {
      const tpl = document.createElement('template');
      tpl.innerHTML = fragments[selector];
      const next = tpl.content.firstElementChild;
      if (next && el.parentNode) el.parentNode.replaceChild(next, el);
    });
  });
  document.body.dispatchEvent(new CustomEvent('kb_cart_refreshed'));
}

function initCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  const panel = drawer.querySelector('[data-cart-panel]');
  const backdrop = drawer.querySelector('[data-cart-backdrop]');
  let lastFocus = null;

  function open() {
    lastFocus = document.activeElement;
    drawer.classList.remove('pointer-events-none');
    drawer.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => {
      backdrop.style.opacity = '1';
      panel.classList.remove('translate-x-full');
    });
    document.body.style.overflow = 'hidden';
    const closeBtn = drawer.querySelector('[data-cart-close]');
    setTimeout(() => closeBtn && closeBtn.focus(), 80);
  }
  function close() {
    drawer.setAttribute('aria-hidden', 'true');
    backdrop.style.opacity = '0';
    panel.classList.add('translate-x-full');
    setTimeout(() => drawer.classList.add('pointer-events-none'), 320);
    document.body.style.overflow = '';
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  document.querySelectorAll('[data-cart-open]').forEach((b) => {
    b.addEventListener('click', (e) => { e.preventDefault(); open(); });
  });

  // [data-cart-close] może być wewnątrz fragmentu — używamy delegacji + bezpośredniego bind dla statycznych.
  // Jeśli element to link z prawdziwym href (nawigacja) — nie preventDefault, drawer zamyka się a link normalnie nawiguje.
  document.addEventListener('click', (e) => {
    const closer = e.target.closest('[data-cart-close]');
    if (closer && drawer.contains(closer)) {
      const href = closer.getAttribute('href');
      const isNavLink = closer.tagName === 'A' && href && href !== '#' && !href.startsWith('javascript:');
      if (!isNavLink) e.preventDefault();
      close();
    }
  });
  backdrop.addEventListener('click', close);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
  });

  // === AJAX: remove / qty change ===

  function setLoading(state) {
    drawer.classList.toggle('is-loading', state);
    if (panel) panel.style.opacity = state ? '0.6' : '';
    if (panel) panel.style.pointerEvents = state ? 'none' : '';
  }

  function removeItem(key) {
    if (!key) return;
    setLoading(true);
    const body = new URLSearchParams();
    body.append('cart_item_key', key);
    fetch(wcAjaxUrl('remove_from_cart'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString(),
    })
      .then((r) => r.json())
      .then((json) => {
        if (json && json.fragments) applyFragments(json.fragments);
        else triggerFragmentRefresh();
      })
      .catch(() => triggerFragmentRefresh())
      .finally(() => setLoading(false));
  }

  function updateQty(key, qty) {
    if (!key) return;
    setLoading(true);
    const body = new URLSearchParams();
    body.append('cart_item_key', key);
    body.append('qty', String(Math.max(0, parseInt(qty, 10) || 0)));
    fetch(wcAjaxUrl('kb_update_cart'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString(),
    })
      .then((r) => r.json())
      .then((json) => {
        if (json && json.fragments) applyFragments(json.fragments);
        else triggerFragmentRefresh();
      })
      .catch(() => triggerFragmentRefresh())
      .finally(() => setLoading(false));
  }

  // Upsell „Dorzuć coś ekstra" — jednym klikiem przez kb_add_to_cart (obsługuje proste;
  // wariantowe mają w markupie link „Wybierz" zamiast przycisku).
  function upsellAdd(btn) {
    const id = btn.getAttribute('data-cart-upsell-add');
    if (!id) return;
    btn.disabled = true;
    btn.textContent = '…';
    setLoading(true);
    const body = new URLSearchParams();
    body.append('product_id', id);
    body.append('quantity', '1');
    fetch(wcAjaxUrl('kb_add_to_cart'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString(),
    })
      .then((r) => r.json())
      .then((json) => {
        if (json && json.error) {
          // Produkt nie do dodania (np. właśnie się sprzedał) — pokaż kartę produktu.
          window.location.href = btn.getAttribute('data-product-url') || json.product_url || '/';
          return;
        }
        if (json && json.fragments) applyFragments(json.fragments);
        else triggerFragmentRefresh();
      })
      .catch(() => triggerFragmentRefresh())
      .finally(() => setLoading(false));
  }

  // Kupony w drawerze — endpointy kb_apply_coupon / kb_remove_coupon (inc/cart-fragments.php).
  // Komunikat wpisujemy PO podmianie fragmentów (fragment wymienia całe body, więc stary
  // element [data-cart-coupon-msg] przestaje istnieć).
  function couponRequest(action, code) {
    setLoading(true);
    const body = new URLSearchParams();
    body.append('coupon_code', code);
    fetch(wcAjaxUrl(action), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString(),
    })
      .then((r) => r.json())
      .then((json) => {
        if (json && json.fragments) applyFragments(json.fragments);
        const msg = drawer.querySelector('[data-cart-coupon-msg]');
        if (msg && json && json.message) {
          msg.textContent = json.message;
          msg.classList.toggle('text-red-700', !json.success);
          msg.classList.toggle('text-black/65', !!json.success);
        }
      })
      .catch(() => triggerFragmentRefresh())
      .finally(() => setLoading(false));
  }

  // Delegacja eventów w obrębie drawera (markup wymieniany przez fragmenty).
  drawer.addEventListener('click', (e) => {
    const upsell = e.target.closest('[data-cart-upsell-add]');
    if (upsell) {
      e.preventDefault();
      upsellAdd(upsell);
      return;
    }
    const applyBtn = e.target.closest('[data-cart-coupon-apply]');
    if (applyBtn) {
      e.preventDefault();
      const input = drawer.querySelector('[data-cart-coupon-input]');
      const code = ((input && input.value) || '').trim();
      if (code) couponRequest('kb_apply_coupon', code);
      return;
    }
    const removeCoupon = e.target.closest('[data-cart-coupon-remove]');
    if (removeCoupon) {
      e.preventDefault();
      couponRequest('kb_remove_coupon', removeCoupon.getAttribute('data-cart-coupon-remove'));
      return;
    }
    const rm = e.target.closest('[data-cart-remove]');
    if (rm) {
      e.preventDefault();
      removeItem(rm.getAttribute('data-cart-remove'));
      return;
    }
    const inc = e.target.closest('[data-cart-qty-inc]');
    if (inc) {
      e.preventDefault();
      const key = inc.getAttribute('data-cart-qty-inc');
      const input = drawer.querySelector(`[data-cart-qty-input="${CSS.escape(key)}"]`);
      const next = (parseInt(input?.value, 10) || 0) + 1;
      if (input) input.value = String(next);
      updateQty(key, next);
      return;
    }
    const dec = e.target.closest('[data-cart-qty-dec]');
    if (dec) {
      e.preventDefault();
      const key = dec.getAttribute('data-cart-qty-dec');
      const input = drawer.querySelector(`[data-cart-qty-input="${CSS.escape(key)}"]`);
      const next = Math.max(0, (parseInt(input?.value, 10) || 0) - 1);
      if (input) input.value = String(next);
      updateQty(key, next);
    }
  });

  // Enter w polu kodu = Zastosuj.
  drawer.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') return;
    const input = e.target.closest('[data-cart-coupon-input]');
    if (!input) return;
    e.preventDefault();
    const code = (input.value || '').trim();
    if (code) couponRequest('kb_apply_coupon', code);
  });

  // Debounce dla manualnego inputu qty.
  let debounceTimer = null;
  drawer.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-qty-input]');
    if (!input) return;
    const key = input.getAttribute('data-cart-qty-input');
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => updateQty(key, input.value), 220);
  });

  // wc_fragments_loaded (z wc-cart-fragments script) — re-bindowanie nie trzeba bo używamy delegacji.
  // Ale jeśli ktoś używa np. dodatkowych inputów to event do podpięcia.
  if (window.jQuery) {
    window.jQuery(document.body).on('wc_fragments_loaded wc_fragments_refreshed', () => {
      document.body.dispatchEvent(new CustomEvent('kb_cart_refreshed'));
    });
  }

  window.kbCartDrawer = { open, close, refresh: triggerFragmentRefresh };
}

if (typeof document !== 'undefined') {
  if (document.readyState !== 'loading') initCartDrawer();
  else document.addEventListener('DOMContentLoaded', initCartDrawer);
}

export {};
